module.exports = __webpack_public_path__ + "static/media/16-min.jpg.a5a80970.webp";